import { useTranslation } from 'react-i18next'
import ReorderPage from '../components/ReorderPage'

const ProjectsReorder = () => {
    const { t } = useTranslation()

    return (
        <div className='min-h-screen bg-gray-100'>
            <ReorderPage
                fetchEndpoint='/admin/projects'
                reorderEndpoint='/admin/projects/reorder'
                title={t('reorder.reorder_projects')}
                getItemImage={item =>
                    item.featured_image || item.image_preview || item.header_image || ''
                }
                getItemTitle={item => item.title || item.name}
                successEndpoint='/admin/auth/projects'
            />
        </div>
    )
}

export default ProjectsReorder
